import React from 'react';

const AddToBagButton = (props) => {
  return (
    <button
      className='btn btn-primary btn-block'
      id='add-to-bag'
      role='button'
      type='button'
      onClick={props.passedFunctions.checkForErrors}
    >
      {props.passedFunctions.parentState.subscriptionFrequency == '' ? 'Add to Bag' : 'Add to Bag & Subscribe'}
    </button>
  );
};

export default AddToBagButton;
